import { CustomFieldKeysResponseObject, DependentFieldsResponseObject } from '@api/v4/resources/CustomFieldKeysTypes';
import { FlattenedCustomFieldKeyValuesMap } from '@components/asset/modal/tabs/edit/EditTabTypes';

export const getDependentCFKeys = (data: DependentFieldsResponseObject[]): string[] =>
  data?.map((dcf) => dcf.attributes.child_key);

export const removeDuplicateFields = (
  cfKeys: CustomFieldKeysResponseObject[]
): CustomFieldKeysResponseObject[] =>
  cfKeys.filter(
    ({ id }, index, self) => index === self.findIndex((cf) => cf.id === id)
  );

// get the custom field values that correspond with the dependent custom fields relevant to the selection
export const matchingCustomFieldsForDCFs = (
  customFieldsResponse: CustomFieldKeysResponseObject[],
  dcfKeys: DependentFieldsResponseObject[]
): CustomFieldKeysResponseObject[] =>
  customFieldsResponse.filter(({ id }) => getDependentCFKeys(dcfKeys)?.includes(id));

// show or remove dependent custom fields based on user selection
export const toggleDependentFields = (
  dcfResponse: DependentFieldsResponseObject[],
  cfv: string,
  cfkId: string
): { keep: DependentFieldsResponseObject[]; remove: DependentFieldsResponseObject[] } => {
  if (dcfResponse?.length) {
    return dcfResponse?.reduce(
      (acc, field) => {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const { attributes: { value, parent_key } } = field;
        if (value === cfv && parent_key === cfkId) {
          acc?.keep?.push(field);
        }
        if (value !== cfv && parent_key === cfkId) {
          acc?.remove?.push(field);
        }
        return acc;
      },
      { keep: [], remove: [] }
    );
  }
};

export const filterForRelevantDependentFields = (
  fields: DependentFieldsResponseObject[],
  customFieldKeyId: string
): DependentFieldsResponseObject[] =>
  fields.filter(({ attributes }) => attributes.parent_key === customFieldKeyId);

export const fieldsToDelete = (
  dependentFields: DependentFieldsResponseObject[],
  customFieldMap: FlattenedCustomFieldKeyValuesMap,
  customFieldKeyId: string
): { customFieldsToDelete: DependentFieldsResponseObject[] } => {
  const relevantDependentFields = filterForRelevantDependentFields(
    dependentFields,
    customFieldKeyId
  );

  const customFieldsToDelete = relevantDependentFields?.filter(
    ({ attributes }) => customFieldMap[attributes.child_key]
  );

  return { customFieldsToDelete };
};
